import * as React from 'react'
import ZocksLogo from '../../../assets/images/zocks-logo-black.svg'
import { Link } from 'react-router-dom'

export interface LoginHeaderProps {
  hideLoginOption?: boolean
}

export const LoginHeader: React.FC<LoginHeaderProps> = ({ hideLoginOption = false }) => (
  <div className='auth-header'>
    <img className='auth-logo' src={ZocksLogo} alt='Zocks logo' />
    {!hideLoginOption ? (
      <div className='auth-header-text'>
        <div>Already have an account?</div>
        <div className='auth-header-link'>
          <Link to={'/login'}>Log in</Link>
        </div>
      </div>
    ) : null}
  </div>
)
